import type { EFMDomainCode } from 'src/features/domains/efmDomains';

/**
 * Default PAM SAQ for each safety-group EFM domain (NHS PAM 2026-27).
 *
 * From water through fire, Safety Hard is one step on from the 2025 numbering:
 * SH9 Water Safety Systems, SH10 Electrical Systems, SH12 Ventilation,
 * SH13 Lifts (requirement sources such as SH13.14), SH15 Fire Safety.
 * LV and HV share that single Electrical Systems SAQ. SH2, SH4–SH6 and
 * Safety Soft (SS1–SS7) are unchanged. Pressure systems (SH14) and medical
 * devices (SH16) already matched this shift.
 */
export const EFM_DOMAIN_PAM_SAQ: Partial<Record<EFMDomainCode, string>> = {
  facility_design: 'SH2',
  health_safety: 'SH4',
  asbestos: 'SH5',
  medical_gas: 'SH6',
  water: 'SH9',
  electrical_lv: 'SH10',
  electrical_hv: 'SH10',
  ventilation: 'SH12',
  lifts: 'SH13',
  pressure_systems: 'SH14',
  fire: 'SH15',
  medical_devices: 'SH16',
  contractor_management: 'SH19',
  mortuary: 'SH20',
  food_safety: 'SS1',
  decontamination: 'SS2',
  waste: 'SS3',
  infection_prevention: 'SS4',
  laundry_linen: 'SS5',
  security: 'SS6',
  transport_logistics: 'SS7',
  helipad: 'H1'
};

export function pamSaqAcronymForEfmDomain(domain: EFMDomainCode | string | null | undefined): string | null {
  if (!domain) return null;
  return EFM_DOMAIN_PAM_SAQ[domain as EFMDomainCode] ?? null;
}
